var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.travelServiceOrderItem.comment !== null &&
      _vm.travelServiceOrderItem.comment.length > 0
        ? [
            _vm._v(
              " " +
                _vm._s(_vm.$t("global.comment")) +
                ": " +
                _vm._s(_vm.travelServiceOrderItem.comment)
            ),
            _c("br")
          ]
        : _vm._e(),
      _c("h3", [_vm._v(_vm._s(_vm.$t("global.passengers")))]),
      _c(
        "ul",
        [
          _vm._l(_vm.travelServiceOrderItem.passengers, function(passenger) {
            return [
              _c(
                "li",
                {
                  key: passenger.id,
                  staticStyle: { "text-transform": "capitalize" }
                },
                [
                  _vm._v(
                    _vm._s(passenger.name) + " " + _vm._s(passenger.surname)
                  )
                ]
              )
            ]
          })
        ],
        2
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }